// pages/Login.js

import { useNavigate } from "react-router-dom";
import API from "../utils/api";


import logo from '../karuncup.svg';
import { useEffect ,useState} from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useSnackbar } from "notistack";
import TextField from "@mui/material/TextField";
import { styled } from '@mui/material/styles';
const CssTextField = styled(TextField)({
  '& label': {
    color: '#FFFF',
  },
  '& .MuiFormHelperText-root': {
    color: '#FFFF', // Correctly targets the helper text
  },
  '& label.Mui-focused': {
    color: '#A0AAB4',
  },
  '& .MuiInputBase-root': {
    color: '#FFFF', // تغییر رنگ متن ورودی
    textAlign: 'center', // وسط‌چین کردن متن انتخاب‌شده
  },
  '& .MuiSelect-select': {
    color: '#FFFF',
    textAlign: 'center', // وسط‌چین کردن متن انتخاب‌شده
  },
  
});
const URL = "api/login";
const LogIn = () => {
  let navigate = useNavigate();
  const [formData, setFormData] = useState({

    password: "",
    email: "",

  });
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();


  const handleLogin = async (ev) => {
    ev.preventDefault();
    const email = ev.target.email.value;
    const password = ev.target.password.value;
    const formData = { email, password };
  
    try {
      
      const res = await API.post(URL,formData);
      
  
      const data = res.data;
  
      if (data.success) {
        enqueueSnackbar(data.message, {
          variant: "success",
          action: (key) => (
            <IconButton onClick={() => closeSnackbar(key)}>
              <CloseIcon style={{ color: "white" }} />
            </IconButton>
          ),
        });
  
        // ذخیره توکن‌ها در localStorage
        localStorage.setItem("access_token", data.access);
        localStorage.setItem("refresh_token", data.refresh);
  
        // هدایت به صفحه پروفایل
        navigate("/profile");
      } else {
        enqueueSnackbar(data.message, {
          variant: "error",
          action: (key) => (
            <IconButton onClick={() => closeSnackbar(key)}>
              <CloseIcon style={{ color: "white" }} />
            </IconButton>
          ),
        });
      }
    } catch (error) {
      const status = error?.response?.status;
      let message;
      if (!error?.response) {
        message = "ارتباط با سرور برقرار نشد. اتصال اینترنت خود را بررسی کنید.";
      } else if (status === 401 || status === 400) {
        message =
          "ایمیل یا رمز عبور اشتباه است. توجه کنید ایمیل و رمز عبور به حروف کوچک و بزرگ حساس هستند؛ دقیقاً همان‌طور که هنگام ثبت‌نام وارد کرده‌اید بنویسید (زبان صفحه‌کلید و Caps Lock را هم بررسی کنید).";
      } else if (status >= 500) {
        message = "خطای سرور رخ داد. لطفاً کمی بعد دوباره تلاش کنید.";
      } else {
        message = error.response.data?.message || "ورود ناموفق بود. لطفاً دوباره تلاش کنید.";
      }
      enqueueSnackbar(message, {
        variant: "error",
        autoHideDuration: 8000,
        action: (key) => (
          <IconButton onClick={() => closeSnackbar(key)}>
            <CloseIcon style={{ color: "white" }} />
          </IconButton>
        ),
      });
    }
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  }; 

  return (
    
    <div className="w-full flex justify-center my-4">
      <div className="w-full max-w-lg p-6 bg-slate-900 border border-slate-800 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
        <img className="w-36 h-36 mx-auto" src={logo} />
        <h5 className="text-2xl font-bold tracking-tight text-white  text-right">
         ورود به کارون کاپ
        </h5>
        <form
          className="w-full flex max-w-md flex-col gap-4"
          onSubmit={handleLogin}
        >
          <CssTextField 
            name="email"
            label="پست الکترونیک"
            value={formData.email}
            onChange={handleChange}
            variant="standard"
          />
          <div className="w-full">
            <div className="items-center justify-between mb-2">
              <div className="text-sm">
                <a
                  href="/forgot-password"
                  className="font-semibold text-lime-600 hover:text-lime-500"
                >
                  رمزت رو فراموش کردی؟
                </a>
              </div>
            </div>
            <CssTextField 
              name="password"
              type="password"
              label="رمزعبور"
              helperText="ایمیل و رمز عبور به حروف کوچک و بزرگ حساس هستند (Case Sensitive)"
              value={formData.password}
              onChange={handleChange}
              variant="standard"
              className="w-full"
            />
          </div>
          <div className="flex items-center gap-2 mb-2" dir="rtl">
            <input
              type="checkbox"
              id="remember"
              className="w-4 h-4 text-lime-600 bg-slate-100 border-slate-300 rounded focus:ring-lime-500  focus:ring-2 "
            />
            <label htmlFor="remember" className="text-sm font-medium">
             من را بخاطر بسپار
            </label>
          </div>
          
          <button
            type="submit"
            className="focus:outline-none text-white bg-lime-600 hover:bg-lime-700 focus:ring-4 focus:ring-lime-300 font-medium rounded-lg text-sm px-5 py-2.5 "
          >
            ورود
          </button>

          <p className="text-center text-sm text-slate-500">
            هنوز ثبت نام نکردی؟{" "}
            <a
              href="sign-up"
              className="font-semibold leading-6 text-lime-600 hover:text-lime-500"
            >
              ثبت نام کن
            </a>
          </p>
        </form>
      </div>
    </div>
  
  );
};

export default LogIn;

